import type {
  HealthCheckCategory,
  HealthCheckFinding,
  HealthCheckGroups,
} from '../models/healthCheck.types'

export function categoryOf(finding: { type: string; isDismissed: boolean }): HealthCheckCategory {
  if (finding.isDismissed) return 'dismissed'
  if (finding.type === 'needs_attention') return 'needs_attention'
  if (finding.type === 'suggestion') return 'suggestions'
  return 'other'
}

export function groupFindings(findings: readonly HealthCheckFinding[]): HealthCheckGroups {
  const groups: HealthCheckGroups = {
    needs_attention: [],
    suggestions: [],
    dismissed: [],
    other: [],
  }
  for (const finding of findings) groups[finding.category].push(finding)
  return groups
}
